import React, { ReactNode, useState } from 'react';
import classNames from 'classnames';
import { Info as InfoOutlined } from 'lucide-react';
import styles from './InfoMessage.module.scss';

export type InfoMessageProps = {
    message: ReactNode;
    isDismissable?: boolean;
    onDismiss?: () => void;
    className?: string;
};

const InfoMessage = (props: InfoMessageProps) => {
    const { message, isDismissable = false, onDismiss } = props;

    const [hasDismissed, setDismissed] = useState(false);

    if (hasDismissed) {
        return null;
    }

    const infoMessageClasses = classNames(styles.infoMessage, props.className);

    return (
        <div className={infoMessageClasses}>
            <InfoOutlined size={20} />
            <div className={styles.message} data-testid='message'>
                {message}
            </div>
            {isDismissable && (
                <button
                    type='button'
                    className={styles.dismiss}
                    onClick={() => {
                        setDismissed(true);
                        onDismiss?.();
                    }}
                    data-testid='dismiss-button'
                >
                    Dismiss
                </button>
            )}
        </div>
    );
};

export default InfoMessage;
